import { useMutationFormeBackendApi } from "@modules/forme/queries";
import { useQueryClient } from "react-query";
import { EULAAcceptanceParams } from "./types";

const useEULAAgreement = () => {
  const queryClient = useQueryClient();

  return useMutationFormeBackendApi<void, EULAAcceptanceParams>({
    method: "POST",
    path: "/v1/clients/eula",
    options: {
      onSuccess: () => {
        // Invalidate the EULA query to refresh the data
        queryClient.invalidateQueries(["forme//v1/clients/eula/"]);
      },
    },
  });
};

export { useEULAAgreement };
